import {Route, Routes, Navigate} from 'react-router-dom';

import LoginPage from '../pages/LoginPage';

export default function AdminRoutes() {
    return (
        <Routes>
            <Route path='/' element={<Navigate to='/auth/login' replace />} />
            <Route path='login' element={<LoginPage />}/>
            <Route path='password' element={<LoginPage />}/>
        </Routes>
    );
}
